import React from 'react';

import SelectionTextBox from './SelectionTextBox.js';
import SelectionInterval from './SelectionInterval.js';
import { DATA_LIMITS } from './Constants.js';

class TemporalWidget extends React.Component {
    constructor(props) {
        super(props);
        
        this.updateTemporalSearch = this.updateTemporalSearch.bind(this);
        this.parseDateStr = this.parseDateStr.bind(this);
        this.viewFullDataset = this.viewFullDataset.bind(this);
    }

    parseDateStr(date_str) {
        return SelectionInterval.fromString(date_str, this.props['data_limits']);
    }

    updateTemporalSearch(intvs) {
        if (intvs.length == 0) {
            this.viewFullDataset();
        }
        else {
            this.props['onintervalchange'](intvs[0], true);
        }
    }

    viewFullDataset() {
        const full_intv = new SelectionInterval(this.props['data_limits']);
        this.props['onintervalchange'](full_intv, true);
    }

    render() {
        let display_intv = this.props['interval'];
        if (display_intv.start().toMillis() == DATA_LIMITS.start.toMillis()
            && display_intv.end().toMillis() == DATA_LIMITS.end.toMillis()
            && !display_intv.isYearly()) {
            display_intv = [];
        }
        else {
            display_intv = [display_intv.toString()];
        }

        return (
            <div id='temporal-controls'>
                <div className='control'>
                    Temporal Search:&nbsp;
                    <SelectionTextBox 
                        content={display_intv}
                        placeholder={"e.g., " + this.props['example']}
                        onselectionupdate={this.updateTemporalSearch}
                        parser={this.parseDateStr}
                    />
                </div>
            </div>
        )
    }
}

export default TemporalWidget;
